 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import ICEMAIDENTHE_COV from '@/components/icemaidenthe_cov'
 import LOVE_1 from '@/components/love_1'
 import ICEMAIDENTHE_TIT01 from '@/components/icemaidenthe_tit01'
 import ICEMAIDENTHE_DED01 from '@/components/icemaidenthe_ded01'
 import ICEMAIDENTHE_EPI from '@/components/icemaidenthe_epi'
 import ICEMAIDENTHE_CON01 from '@/components/icemaidenthe_con01'
 import ICEMAIDENTHE_CH01 from '@/components/icemaidenthe_ch01'
 import ICEMAIDENTHE_CH02 from '@/components/icemaidenthe_ch02'
 import ICEMAIDENTHE_CH03 from '@/components/icemaidenthe_ch03'
 import ICEMAIDENTHE_CH04 from '@/components/icemaidenthe_ch04'
 import ICEMAIDENTHE_CH05 from '@/components/icemaidenthe_ch05'
 import ICEMAIDENTHE_CH06 from '@/components/icemaidenthe_ch06'
 import ICEMAIDENTHE_CH07 from '@/components/icemaidenthe_ch07'
 import ICEMAIDENTHE_CH08 from '@/components/icemaidenthe_ch08'
 import ICEMAIDENTHE_CH09 from '@/components/icemaidenthe_ch09'
 import ICEMAIDENTHE_CH10 from '@/components/icemaidenthe_ch10'
 import ICEMAIDENTHE_CH11 from '@/components/icemaidenthe_ch11'
 import ICEMAIDENTHE_CH12 from '@/components/icemaidenthe_ch12'
 import ICEMAIDENTHE_CH13 from '@/components/icemaidenthe_ch13'
 import ICEMAIDENTHE_CH14 from '@/components/icemaidenthe_ch14'
 import ICEMAIDENTHE_CH15 from '@/components/icemaidenthe_ch15'
 import ICEMAIDENTHE_CH16 from '@/components/icemaidenthe_ch16'
 import ICEMAIDENTHE_CH17 from '@/components/icemaidenthe_ch17'
 import ICEMAIDENTHE_CH18 from '@/components/icemaidenthe_ch18'
 import ICEMAIDENTHE_CH19 from '@/components/icemaidenthe_ch19'
 import ICEMAIDENTHE_CH20 from '@/components/icemaidenthe_ch20'
 import ICEMAIDENTHE_CH21 from '@/components/icemaidenthe_ch21'
 import ICEMAIDENTHE_CH22 from '@/components/icemaidenthe_ch22'
 import ICEMAIDENTHE_CH23 from '@/components/icemaidenthe_ch23'
 import ICEMAIDENTHE_CH24 from '@/components/icemaidenthe_ch24'
 import LOVE_2 from '@/components/love_2'
 import ICEMAIDENTHE_BM01 from '@/components/icemaidenthe_bm01'
 import ICEMAIDENTHE_ATA01 from '@/components/icemaidenthe_ata01'
 import ICEMAIDENTHE_BM02 from '@/components/icemaidenthe_bm02'
 import ICEMAIDENTHE_BM03 from '@/components/icemaidenthe_bm03'
 import ICEMAIDENTHE_COP01 from '@/components/icemaidenthe_cop01'
 import ICEMAIDENTHE_ATP01 from '@/components/icemaidenthe_atp01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/icemaidenthe_cov",
 			"name" : "icemaidenthe_cov",
 			"component" : ICEMAIDENTHE_COV
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/icemaidenthe_tit01",
 			"name" : "icemaidenthe_tit01",
 			"component" : ICEMAIDENTHE_TIT01
 		},
 		{
 			"path" : "/icemaidenthe_ded01",
 			"name" : "icemaidenthe_ded01",
 			"component" : ICEMAIDENTHE_DED01
 		},
 		{
 			"path" : "/icemaidenthe_epi",
 			"name" : "icemaidenthe_epi",
 			"component" : ICEMAIDENTHE_EPI
 		},
 		{
 			"path" : "/icemaidenthe_con01",
 			"name" : "icemaidenthe_con01",
 			"component" : ICEMAIDENTHE_CON01
 		},
 		{
 			"path" : "/icemaidenthe_ch01",
 			"name" : "icemaidenthe_ch01",
 			"component" : ICEMAIDENTHE_CH01
 		},
 		{
 			"path" : "/icemaidenthe_ch02",
 			"name" : "icemaidenthe_ch02",
 			"component" : ICEMAIDENTHE_CH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js